
import { Amplify } from 'aws-amplify';
import awsExports from '../../aws-exports';

export const configureAmplify = () => {
  // Only configure the hosting part of Amplify
  // We're not using Amplify's auth or database features
  Amplify.configure({
    ...awsExports,
    // No Auth configuration - using Supabase
    // No API configuration - using Supabase
  });
};
